
export const SET_MSG = 'DEPEDENTE_MSG';
export const SET_EDITAR = 'DEPEDENTE_EDITAR';
export const SET_LISTA = 'DEPEDENTE_LISTA';
export const SET_TRABALHADORES = 'DEPEDENTE_TRABALHADORES';
export const SET_TOMADORES = 'DEPEDENTE_TOMADORES';